import * as S from "./styles.ts";
import { Button, H2 } from "@template/components";
import { IButtonProps } from "@template/components/Button";

const Header = ({
                  title,
                  button,
                }: {
  title?: string;
  button?: IButtonProps;
}) => {
  if (!title && !button) return;
  return (
    <S.Wrapper>
      {title && <H2>{title}</H2>}
      {button?.children && <Button {...button} />}
    </S.Wrapper>
  );
};

export default Header;
